import { useStoreSettings } from '../../../modules/settings/hooks/useSettings.js';

/**
 * Lucide icon names die beschikbaar zijn voor modules.
 * Wordt gebruikt in de Settings UI als icon-picker.
 */
export const AVAILABLE_ICONS = [
  'Wrench', 'HardHat', 'Hammer', 'Truck', 'Package', 'ClipboardList',
  'FolderOpen', 'Briefcase', 'Ruler', 'PenTool', 'Cog', 'ShieldCheck',
  'Home', 'Building2', 'MapPin', 'Users', 'CalendarCheck', 'FileText',
  'LayoutGrid', 'MessageSquare', 'Store', 'UserCircle', 'CalendarDays',
  'Warehouse', 'MessageCircle', 'Contact',
] as const;

export type IconName = typeof AVAILABLE_ICONS[number];

export interface ModuleLabel {
  label: string;
  icon: IconName;
}

export interface ModuleLabelsConfig {
  buitendienst: ModuleLabel;
  logistiek: ModuleLabel;
  planning: ModuleLabel;
  communicatie: ModuleLabel;
  crm: ModuleLabel;
  winkel: ModuleLabel;
}

/** Standaard labels — worden gebruikt als geen custom config is ingesteld */
const DEFAULT_LABELS: ModuleLabelsConfig = {
  buitendienst: { label: 'Buitendienst', icon: 'HardHat' },
  logistiek:    { label: 'Logistiek',    icon: 'Truck' },
  planning:     { label: 'Planning',     icon: 'CalendarDays' },
  communicatie: { label: 'Communicatie',  icon: 'MessageCircle' },
  crm:          { label: 'CRM',          icon: 'Contact' },
  winkel:       { label: 'Winkel',       icon: 'Store' },
};

/**
 * Hook die de configureerbare modulenamen en iconen teruggeeft.
 * Leest uit StoreSettings.moduleLabels; valt terug op defaults.
 */
export function useModuleLabels(): ModuleLabelsConfig & { isLoading: boolean } {
  const { data: settings, isLoading } = useStoreSettings();

  const custom = (settings as any)?.moduleLabels as Partial<ModuleLabelsConfig> | undefined;

  const merged: ModuleLabelsConfig = {
    buitendienst: { ...DEFAULT_LABELS.buitendienst, ...custom?.buitendienst },
    logistiek:    { ...DEFAULT_LABELS.logistiek,    ...custom?.logistiek },
    planning:     { ...DEFAULT_LABELS.planning,     ...custom?.planning },
    communicatie: { ...DEFAULT_LABELS.communicatie,  ...custom?.communicatie },
    crm:          { ...DEFAULT_LABELS.crm,          ...custom?.crm },
    winkel:       { ...DEFAULT_LABELS.winkel,       ...custom?.winkel },
  };

  return { ...merged, isLoading };
}

export { DEFAULT_LABELS };
